import axios, {AxiosResponse} from "axios";
import {retry} from "@me8eon/retry_utils";
import {ellipsesInMiddle} from "@me8eon/string_utils";
import {EnvironmentConfig} from "@me8eon/config";
import {AiToolImpl} from "@me8eon/aiclient";
import {GetServiceRequestResponse} from "./model/types";
import { JwtTokenFn } from "@me8eon/authentication";

export const GetUserIncidentsToolImplGenerator = (jwtTokenFn: JwtTokenFn): AiToolImpl<any> => {
    return {
        type: "service_api",
        toolDefn: {
            type: 'function',
            name: "get_user_incidents",
            description: "This tool fetches the user's current incidents(service requests) from the ServiceNow platform. It returns a list of service requests with their details.",
            parameters: {
                required: [],
                additionalProperties: false,
                type: "object",
                properties: {}
            },
        },
        execute: async () => {

            const asyncFn: () => Promise<AxiosResponse<GetServiceRequestResponse>> = async () => await axios.get(`${EnvironmentConfig.nodeService}/service/incidents?isActive=true`, {
                headers: { Authorization: `Bearer ${await jwtTokenFn()}` },
            });
            try {
                const response = await retry(asyncFn)

                const orderData = response.data.result.queryResult.map((item) => ({
                    ...item,
                    description: ellipsesInMiddle(item.description, 100)
                }));
                const ordersJson = JSON.stringify(orderData, null, 2);

                return {
                    value: `Here are the user's incidents:\n\n${ordersJson}`
                }
            } catch (error) {
                return {
                    value: `Could not fetch user incidents due to an error. User should be informed accordingly.`
                }
            }
        }
    }
}